import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "@/app/App";
import "yeati-ui/style.css";
import "./style/style.css";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";

// Recover from stale module preload failures after a deploy. Vite fires
// `vite:preloadError` when a CSS chunk referenced by the old bundle can't be
// loaded; the same condition also breaks dynamic JS imports (handled in
// lazyWithRetry). A hard reload makes the browser pick up the new bundle.
const RELOAD_AT_KEY = "yeati:lazyChunkReloadedAt";
const RELOAD_COOLDOWN_MS = 30_000;

window.addEventListener("vite:preloadError", () => {
  const lastReload = Number(window.sessionStorage.getItem(RELOAD_AT_KEY)) || 0;
  if (Date.now() - lastReload < RELOAD_COOLDOWN_MS) return;
  window.sessionStorage.setItem(RELOAD_AT_KEY, String(Date.now()));
  window.location.reload();
});

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
